import React, { ComponentProps } from 'react';
import { IconType } from 'react-icons';
import clsx from 'clsx';

import styles from './styles.module.scss';

type QueueHeaderProps = {
  Icon: IconType;
  children: React.ReactNode;
} & ComponentProps<'div'>;
export function QueueHeader({ Icon, children, className, ...props }: QueueHeaderProps) {
  return (
    <div className={clsx(styles['queue-header'], className)} {...props}>
      <Icon size={28} />
      <h1>{children}</h1>
    </div>
  );
}
